// ConversionContext.js
import React, { createContext, useState, useEffect, useContext, useCallback, useRef } from 'react';
import axios from 'axios';
import { AuthContext } from './AuthContext';
import API_BASE_URL from '../config';

export const ConversionContext = createContext();

export const ConversionProvider = ({ children }) => {
  const { user } = useContext(AuthContext); // Ottieni l'utente dal contesto Auth
  const [conversions, setConversions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const activeRequest = useRef(null);

  // Funzione per recuperare le conversioni dal database
  const fetchConversions = useCallback(async () => {
    if (!user) return; // Evita richieste se l'utente non è autenticato
    activeRequest.current?.abort();
    const controller = new AbortController();
    activeRequest.current = controller;
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${API_BASE_URL}/gambling/conversions`, {
        params: { aff_var: user },
        signal: controller.signal,
      });
      const conversionData = response.data.conversions || [];
      const sortedConversions = conversionData.sort((a, b) => new Date(b.date) - new Date(a.date));
      if (!controller.signal.aborted) setConversions(sortedConversions);
    } catch (err) {
      if (!controller.signal.aborted) setError('Unable to load conversions');
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }, [user]);

  // Funzione per aggiornare le conversioni dall'API esterna
  const updateConversions = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/gambling/fetch-conversions`);
      await fetchConversions();
      return response.data.upsertedCount; // Solo le conversioni effettivamente nuove
    } catch (err) {
      console.error('Errore durante l\'aggiornamento delle conversioni:', err);
      throw err;
    }
  };

  // Carica le conversioni all'inizializzazione del contesto
  useEffect(() => {
    setConversions([]);
    setError(null);
    setLoading(Boolean(user));
    fetchConversions();
    return () => activeRequest.current?.abort();
  }, [user, fetchConversions]);

  return (
    <ConversionContext.Provider value={{ conversions, loading, error, fetchConversions, updateConversions }}>
      {children}
    </ConversionContext.Provider>
  );
};
